import { render, staticRenderFns } from "./HomeOwner.vue?vue&type=template&id=412d72c0&"
import script from "./HomeOwner.vue?vue&type=script&lang=js&"
export * from "./HomeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports